const PropertiesModel = Mindbreeze['require']('model/properties');

export function getPropertyValue(result, propertyName: String) {
  if (!result) return;

  return new PropertiesModel(result.properties).get(propertyName, {
    format: 'VALUE',
  });
}

export function createHtmlProperty(propertyName: String, ...html: String[]) {
    return {
        id: propertyName,
        name: propertyName,
        data: html.map(value => ({
            html: value
        }))
    }
}
